import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Card, Tab, Tabs, Spinner } from 'react-bootstrap';
import { useOutletContext, useParams, useNavigate } from 'react-router-dom';
//import spinnerIcon from './/./../assets/img/loadingSpinner.gif'
import SpinnerComponent from '../components/progressbar/SpinnerComponent.js'
import PaginationComponent from '../components/pagination/PaginationComponent.js'
import { useAuth0 } from "@auth0/auth0-react";
import { apiGet, apiPut } from "../services/AuthService.js";
import {
    btnGold, boxshadowHover, boxshadowUnHover,
    formLabel, inputSm, goldInputFocus,
    paginationStyle, activePaginationStyle, COLORS
} from '../styles/goldTheme.js'

const ClassificationCodes_dc = props => {

    //properties
    const baseUrl = process.env.REACT_APP_API_BASEURL;
    const { getAccessTokenSilently } = useAuth0();

    //stateful properties (hooks)
    const params = useParams();
    const [currentAccount, accountProfile, setAccountProfile, toggleIsShowSidebarMd, setIsShowSidebarMd] = useOutletContext();
    const navigate = useNavigate();

    //admin-only global mappings view. accountId comes from props when embedded
    //(AdminDashboard Global Mappings tab) or from the URL param when navigated
    //to standalone (/classificationcodes_dc/69). 69 = TOTData Global Mapping account (Dev).
    const targetAccountId = props.accountId || params.accountId;
    const [pageStatus, setPageStatus] = useState('loading');
    const [dataStatus, setDataStatus] = useState('loading');
    const [pageErrors, setPageErrors] = useState('');
    const [dataErrors, setDataErrors] = useState('');
    const [classificationTypes, setClassificationTypes] = useState([{ code: '', value: '' }, { code: 'CAPITAL', value: 'CAPITAL' }, { code: 'EXPENSE', value: 'EXPENSE' }, { code: 'NET', value: 'NET' }, { code: 'CASH_CALL', value: 'CASH_CALL' }]);
    const [originalClassificationCodes, setOriginalClassificationCodes] = useState([]);
    const [classificationCodes, setClassificationCodes] = useState([]);
    const [selectedClassificationIndex, setSelectedClassificationIndex] = useState(null);
    const [selectedClassification, setSelectedClassification] = useState(null);
    const [anyClassificationDirty, setAnyClassificationDirty] = useState(false);
    //const [anyTransactionDirty, setAnyTransactionDirty] = useState(false);
    const [isReadOnly, setIsReadOnly] = useState(true);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [dataCriteria, setDataCriteria] = useState({
        skipCount: 0,
        takeCount: 25
    });
    const [rowCount, setRowCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const companyTopRef = useRef(null);
    const editRef = useRef(null);

    //initialize page
    useEffect(() => {
        (async () => {
            //console.log('Initializing page...');

            //skip sidebar toggle when embedded inside AdminDashboard so we don't
            //fight with whatever sidebar state AdminDashboard already set
            if (!props.embedded && setIsShowSidebarMd)
                setIsShowSidebarMd(true);

            await initializeForm()
                .then(initializeResponse => {
                    populateMajorAccountCodes(1)
                        .then(response => {
                            setPageStatus('ready')
                        })
                        .catch(ex => {
                            setPageStatus('error');
                            setPageErrors(ex.message);

                            setDataStatus('error');
                            setDataErrors(ex.message);
                        })
                        .finally(response => {
                            //do something
                        })
                })
                .catch(ex => {
                    setPageStatus('error');
                    setPageErrors(ex.message);
                })
                .finally(response => {
                    //do something
                })
        })();
    }, []);

    //initialize form
    const initializeForm = async () => {
        //TODO: might just call populateOperators() from useEffect
        //console.log('Initializing form...');

        return { success: true };

        //TODO: might want to clean this up with .then /.catch, but how to do with multiple api calls?
        //.then(get other data)
        //.catch(ex => throw...)
    };

    //populate productCodes
    const populateMajorAccountCodes = async (currentPage, reset) => {
        //console.log('Current Page: ' + currentPage);

        //note: have to recalcaulate skipCount here since state updates aren't active until re-render
        let skipCount = (currentPage === 1 ? 0 : (currentPage - 1) * dataCriteria.takeCount);
        //console.log('Skip Count: ' + skipCount);

        //setDataStatus('loading');

        const currentCriteria = {
            skipCount: skipCount,
            takeCount: dataCriteria.takeCount
        }

        await getMajorAccountCodes(currentCriteria)
            .then(response => {
                if (response.data.length === 0) {
                    //console.log(response.data);
                    setHoveredIndex(null);
                    setSelectedClassificationIndex(null);
                    setSelectedClassification(null);
                    setAnyClassificationDirty(false);
                    //setAnyTransactionDirty(false);
                    setDataStatus('nodata')
                }
                else {
                    //console.log('Company Count: ' + response.data[0].rowCount);
                    setIsReadOnly(true);
                    setHoveredIndex(null);
                    setSelectedClassificationIndex(0);
                    setSelectedClassification(response.data[0]);
                    setAnyClassificationDirty(false);
                    //setAnyTransactionDirty(false);

                    setRowCount(response.rowCount);
                    setOriginalClassificationCodes(response.data);
                    setClassificationCodes(response.data);
                    setDataStatus('ready')
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    };

    //get productCodes
    const getMajorAccountCodes = async (criteria) => {
        //console.log('Getting CdexProductCodes...');

        const apiUrl = 'accounts/' + targetAccountId + '/majoraccountcodes?skipcount=' + criteria.skipCount + '&takecount=' + criteria.takeCount + '&documentType=DC_REV';
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json();
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, rowCount: json.rowCount, data: json.data };
    };

    //handle product changes
    const handleClassificationChange = (event) => {
        event.preventDefault();

        const fieldName = event.target.name;
        let value = event.target.value;
        //console.log('ownerId: ' + ownerId, 'Field: ' + fieldName + ', Value: ' + value);

        let anyClassificationDirty = false;
        let anyClassificationInvalid = false;
        const newClassificationtList = [];
        classificationCodes.map((classification, index) => {
            if (index === selectedClassificationIndex) {
                const originalClassification = originalClassificationCodes[index];
                const originalValue = originalClassification.majorClassCode;

                const isDirty = (value !== originalValue ? true : false);
                const isValid = (value !== '' ? true : false);

                newClassificationtList.push({
                    ...classification,
                    [fieldName]: value,
                    isDirty: isDirty,
                    isValid: isValid
                });

                if (isDirty && isValid)
                    anyClassificationDirty = true;

                if (isDirty && !isValid)
                    anyClassificationInvalid = true;

                //console.log('Updating product: ' + product.productCode);
            }
            else {
                newClassificationtList.push(classification);

                if (classification.isDirty && classification.isValid)
                    anyClassificationDirty = true;

                if (classification.isDirty && !classification.isValid)
                    anyClassificationInvalid = true;
            }
        });
        setClassificationCodes(newClassificationtList);

        setAnyClassificationDirty(anyClassificationDirty && !anyClassificationInvalid);

        newClassificationtList.map(classification => {
            console.log('New Classification: ' + classification.majorAccountCode + ', ' + classification.majorAccountDesc + ', ' + classification.majorClassCode + ', ' + classification.isDirty);
        });
    }

    //handle transaction changes
    //const handleTransactionChange = (currentIndex, event) => {
    //    event.preventDefault();

    //    const fieldName = event.target.name;
    //    let value = event.target.value;
    //    //console.log('Current Index: ' + currentIndex + ', Field: ' + fieldName + ', Value: ' + value);

    //    if (fieldName == 'cdexTransactionCode') {
    //        if (value.length > 3) {
    //            value = value.substring(0, 3);
    //        }
    //    }

    //    let anyTransactionDirty = false;
    //    let anyTransactionInvalid = false;
    //    const newProductList = [];
    //    const newTransactionList = [];
    //    productCodes.map((product, productIndex) => {
    //        const originalProduct = originalProductCodes[productIndex];

    //        if (productIndex === selectedProductIndex) {

    //            product.cdexTransactionRowDTO.data.map((transaction, transactionIndex) => {

    //                if (transactionIndex === currentIndex) {
    //                    const originalTransaction = originalProduct.cdexTransactionRowDTO.data[transactionIndex];
    //                    const originalCdexTranCode = originalTransaction.cdexTransactionCode;
    //                    const originalRevLineTypeCode = originalTransaction.revLineTypeCode;

    //                    const cdexTranCodeValue = fieldName === 'cdexTransactionCode' ? value : transaction.cdexTransactionCode;
    //                    const revLineTypeCode = fieldName === 'revLineTypeCode' ? value : transaction.revLineTypeCode;
    //                    const isDirty = (cdexTranCodeValue !== originalCdexTranCode || revLineTypeCode !== originalRevLineTypeCode);
    //                    const isValid = (cdexTranCodeValue !== '' && revLineTypeCode !== '') || (cdexTranCodeValue === '' && revLineTypeCode === '');

    //                    newTransactionList.push({
    //                        ...transaction,
    //                        [fieldName]: value,
    //                        isDirty: isDirty,
    //                        isValid: isValid
    //                    });

    //                    if (isDirty && isValid)
    //                        anyTransactionDirty = true;

    //                    if (isDirty && !isValid)
    //                        anyTransactionInvalid = true;
    //                }
    //                else {
    //                    newTransactionList.push(transaction);

    //                    if (transaction.isDirty && transaction.isValid)
    //                        anyTransactionDirty = true;

    //                    if (transaction.isDirty && !transaction.isValid)
    //                        anyTransactionInvalid = true;
    //                }
    //            });

    //            newProductList.push({
    //                ...product,
    //                cdexTransactionRowDTO: { ...product.cdexTransactionRowDTO, data: newTransactionList }
    //            });

    //            //console.log('Updating transaction: ' + transaction.transactionCode);
    //        }
    //        else {
    //            newProductList.push(product);
    //        }
    //    });
    //    setProductCodes(newProductList);
    //    setSelectedProduct(newProductList[selectedProductIndex]);
    //    setAnyTransactionDirty(anyTransactionDirty && !anyTransactionInvalid);

    //    newProductList.map((product, productIndex) => {
    //        console.log('New Product: ' + product.productCode + ', ' + product.productDesc + ', ' + product.cdexProductCode + ', ' + product.isDirty);

    //        if (productIndex === selectedProductIndex) {
    //            product.cdexTransactionRowDTO.data.map(transaction => {
    //                console.log('New Transaction: ' + transaction.transactionCode + ', ' + transaction.transactionDesc + ', ' + transaction.cdexTransactionCode + ', ' + transaction.revLineTypeCode + ', ' + transaction.isDirty + ', ' + transaction.isValid);
    //            });
    //        }
    //    });
    //}

    //update products
    const updateClassifications = async () => {
        console.log('Updating Classifications...');
        setDataStatus('loading');

        //disable Map buttons while mapping
        //const tranDirtyState = anyTransactionDirty;
        //setAnyTransactionDirty(false);
        setAnyClassificationDirty(false);

        //console.log('Id: ' + selectedProduct.id + ', Product Code: ' + selectedProduct.productCode);

        await saveClassifications()
            .then(response => {
                if (response.success) {
                    setAnyClassificationDirty(false);
                    setOriginalClassificationCodes(response.data);
                    setClassificationCodes(response.data);
                    setSelectedClassification(response.data[selectedClassificationIndex]);
                    //setAnyTransactionDirty(tranDirtyState);
                    setDataStatus('ready')
                }
                else {
                    //TODO: figure out what to do here
                    console.log('nodata');
                    //setDataStatus('nodata')
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    };

    //save products
    const saveClassifications = async () => {
        //console.log('Saving Products...');

        const apiUrl = 'accounts/' + targetAccountId + '/updatemajoraccountcodes';
        const jsonBody = JSON.stringify(classificationCodes);
        //console.log(apiUrl);
        //console.log(jsonBody);

        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
        const json = await response.json();

        return { success: response.ok, data: json };
    };

    //add a new major account (UI scaffold — backend wiring TBD)
    const handleAddAccount = () => {
        console.log('TODO: open Add Account modal');
    };

    //update transaction
    //const updateTransactions = async () => {
    //    console.log('Updating Transactions...');
    //    setDataStatus('loading');

    //    //disable Map buttons while mapping
    //    const prodDirtyState = anyProductDirty;
    //    setAnyTransactionDirty(false);
    //    setAnyProductDirty(false);

    //    //console.log('Id: ' + selectedProduct.id + ', Product Code: ' + selectedProduct.productCode);

    //    await saveTransactions()
    //        .then(response => {
    //            if (response.success) {
    //                setAnyTransactionDirty(false);

    //                const newProductList = [];
    //                productCodes.map((product, index) => {
    //                    if (index === selectedProductIndex) {
    //                        newProductList.push(response.data);
    //                    }
    //                    else {
    //                        newProductList.push(product);
    //                    }
    //                });
    //                setOriginalProductCodes(newProductList);
    //                setProductCodes(newProductList);
    //                setSelectedProduct(newProductList[selectedProductIndex]);

    //                setAnyProductDirty(prodDirtyState);
    //                setDataStatus('ready')
    //            }
    //            else {
    //                //TODO: figure out what to do here
    //                console.log('nodata');
    //                //setDataStatus('nodata')
    //            }
    //        })
    //        .catch(ex => {
    //            setDataStatus('error');
    //            setDataErrors(ex.message);
    //        })
    //        .finally(response => {
    //            //do something
    //        })
    //};

    //save transactions
    //const saveTransactions = async () => {
    //    console.log('Saving Transactions...');

    //    const apiUrl = 'accounts/' + currentAccount.id + '/updatetransactioncodes';
    //    const jsonBody = JSON.stringify(selectedProduct);
    //    //console.log(apiUrl);
    //    //console.log(jsonBody);

    //    const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
    //    const json = await response.json();

    //    return { success: response.ok, data: json };
    //};

    //handle mouse over
    const handleMouseOver = async (index) => {
        console.log('Mouse Over: ' + index);

        if (index != selectedClassificationIndex) {
            setHoveredIndex(index);
        }
    };

    //handle mouse leave
    const handleMouseLeave = async (index) => {
        console.log('Mouse Leave: ' + index);

        if (index != selectedClassificationIndex) {
            setHoveredIndex(null);
        }
    };

    //handle mouse click
    const handleMouseClick = async (index) => {
        console.log('Mouse Click: ' + index);

        setHoveredIndex(null);
        setSelectedClassificationIndex(index);
        setSelectedClassification(classificationCodes[index]);

        //let anyTransactionDirty = false;
        //let anyTransactionInvalid = false;
        //productCodes[index].cdexTransactionRowDTO.data.map(transaction => {
        //    if (transaction.isDirty && transaction.isValid) {
        //        anyTransactionDirty = true;
        //    }

        //    if (transaction.isDirty && !transaction.isValid) {
        //        anyTransactionInvalid = true;
        //    }
        //});
        //setAnyTransactionDirty(anyTransactionDirty && !anyTransactionInvalid);
    };

    //handle page click
    const handlePageClick = async (currentPage) => {
        //console.log('Current Page: ' + currentPage);

        //setDataStatus('loading');

        setDataCriteria({
            ...dataCriteria,
            skipCount: 0
        });

        //don't need to do here, since pagination component sets before calling this method
        //setCurrentPage(1);

        await populateMajorAccountCodes(currentPage);
    };

    //render page loading
    //note: spinner overlay will eventually be at the page level (I think)
    const showPageLoading = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
                <Spinner animation="border" style={{ color: COLORS.gold }} />
            </div>
        );
    }

    //render page loading
    const showDataLoading = () => {
        return (
            <Row style={{ justifyContent: 'center', padding: '40px 0' }}>
                <Spinner animation="border" style={{ color: COLORS.gold, width: 'auto' }} />
            </Row>
        );
    }

    //render page error
    const showPageError = () => {
        return (
            <div>
                Oops, there was a page load error: {pageErrors}
            </div>
        );
    }

    //render data error
    const showDataError = () => {
        return (
            <Row>
                Oops, there was a data load error: {dataErrors}
            </Row>
        );
    }

    //render table container
    const showTableContainer = () => {
        return (
            <Card className="mb-4" style={{ background: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 14px rgba(0,0,0,.10)' }}>
                <Card.Header style={{ background: '#333333', color: '#f1f1f1', borderBottom: 'none', padding: props.embedded ? '8px 12px' : '12px 16px' }}>
                    {showInputCriteria()}
                </Card.Header>
                <Card.Body style={{ paddingLeft: '12px', paddingRight: '10px' }} >
                    {(() => {
                        switch (dataStatus) {
                            case 'nodata':
                                return <p>No Data Loaded.</p>
                            case 'loading':
                                return showDataLoading()
                            case 'ready':
                                return showData()
                            case 'error':
                                return showDataError()
                            default:
                                return <Row>No Data Loaded.</Row>
                        }
                    })()}
                </Card.Body>
            </Card>
        );
    }

    //render productCodes
    const showData = () => {
        return (
            <Row>
                <Col xs={5} style={{ marginTop: '-16px', marginBottom: '-16px', overflow: 'auto', paddingRight: '0px', paddingLeft: '0px', borderRight: '1px solid #e5e7eb' }} >
                    {(() => {
                        switch (dataStatus) {
                            case 'ready':
                                return showDataMaster()
                            default:
                                return null
                        }
                    })()}
                </Col>
                {/*<Col xs={7} style={{ height: '530px', overflow: 'auto', paddingLeft: '20px', marginTop: '-10px', marginBottom: '-16px' }}>*/}
                {/*    {(() => {*/}
                {/*        switch (dataStatus) {*/}
                {/*            case 'ready':*/}
                {/*                return showDataDetail()*/}
                {/*            default:*/}
                {/*                return null*/}
                {/*        }*/}
                {/*    })()}*/}
                {/*</Col>*/}
            </Row>
        );
    }

    //render master pane (productCodes list)
    const showDataMaster = () => {
        return (
            <>
                <ul style={{ listStyleType: "none", height: props.embedded ? "390px" : "515px", marginRight: '12px' }}>
                    {classificationCodes.map((majorAccountCode, index) => (
                        <li key={index} ref={(index == 0 ? companyTopRef : null)}
                            style={{ cursor: 'pointer', paddingLeft: '20px', marginLeft: '-42px', marginRight: '0px', fontSize: props.embedded ? '.8rem' : '.9rem' }}
                            onMouseOver={() => handleMouseOver(index)}
                            onMouseLeave={() => handleMouseLeave(index)}
                            onClick={() => handleMouseClick(index)}>
                            <Row style={{
                                borderTop: hoveredIndex == index ? `2px solid ${COLORS.gold}` : '2px solid transparent',
                                borderBottom: hoveredIndex == index ? `2px solid ${COLORS.gold}` : '1px solid #e5e7eb',
                                backgroundColor: (selectedClassificationIndex == index ? '#f5f0e8' : (index % 2 === 0 ? '#fafbfc' : 'transparent')),
                                color: selectedClassificationIndex == index ? '#1f2937' : '#374151',
                                fontWeight: selectedClassificationIndex == index ? 600 : 400,
                                borderLeft: selectedClassificationIndex == index ? `5px solid ${COLORS.gold}` : '5px solid transparent',
                                paddingTop: '4px',
                                paddingBottom: '4px',
                                transition: 'border-color 120ms ease, background 120ms ease, color 120ms ease'
                            }} >
                                {/* Major Account Code column hidden for _dc */}
                                <Col xs={7} style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>{majorAccountCode.majorAccountDesc}</div>
                                </Col>
                                <Col xs={5}>
                                    {(() => {
                                        if (!majorAccountCode.isReadOnly) {
                                            return <Form.Group className={props.embedded ? "mb-0" : "mb-3"} controlId="majorClassCode">
                                                <Form.Select name="majorClassCode" size="sm" aria-label="Major Class Code" value={majorAccountCode.majorClassCode} style={props.embedded ? { fontSize: '.78rem', padding: '0px 22px 0px 6px', height: '22px', lineHeight: 1.2, backgroundPosition: 'right 4px center' } : undefined} onChange={e => handleClassificationChange(e)}>
                                                    {classificationTypes.map((type, i) => (
                                                        <option key={i} value={type.code}>{type.value}</option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        }
                                        else {
                                            return <div>
                                                {majorAccountCode.majorClassCode}
                                            </div>
                                        }
                                    })()}
                                </Col>
                            </Row>
                        </li>
                    ))}
                </ul>
            </>
        );
    }

    //render detail pane (company display or edit)
    //const showDataDetail = () => {
    //    return (
    //        <>
    //            {(() => {
    //                if (isReadOnly) {
    //                    //return showDataDisplay()
    //                    //return showDataEdit()
    //                }
    //                else {
    //                    //return showDataEdit()
    //                    return showDataDisplay()
    //                }
    //            })()}
    //        </>
    //    );
    //}

    //render company detail
    //const showDataDisplay = () => {
    //    return (
    //        <>
    //            <Row>
    //                <Col xs={8}>
    //                    <div style={{ fontWeight: '600', fontSize: '1.25rem', marginTop: '10px' }} >Sender Detail</div>
    //                </Col>
    //                <Col xs={4} className="d-flex justify-content-end" style={{ marginTop: '13px' }} >
    //                    Company Code:&nbsp;&nbsp;{selectedProduct.companyCode}&nbsp;&nbsp;&nbsp;&nbsp;
    //                </Col>
    //            </Row>
    //            <Form style={{ borderTop: 'solid lightgray 1px', marginTop: '10px', paddingRight: '10px' }} />
    //            <Row style={{ paddingRight: '10px', paddingTop: '10px' }}>
    //                <Col xs={2}>
    //                    Name:
    //                </Col>
    //                <Col xs={10}>
    //                    <div>
    //                        {selectedProduct.companyName}
    //                    </div>
    //                    <div>
    //                        {((selectedProduct.additionalNameInfo ?? '') == '' ? null : '(' + selectedProduct.additionalNameInfo + ')')}
    //                    </div>
    //                </Col>
    //            </Row>
    //            <Row>
    //                <Col xs={2}>
    //                    Address:
    //                </Col>
    //                <Col xs={10}>
    //                    <div>
    //                        {selectedProduct.address1} {selectedProduct.address2} {selectedProduct.address3}
    //                    </div>
    //                    <div>
    //                        {selectedProduct.city}, {selectedProduct.state} {selectedProduct.zip}
    //                    </div>
    //                </Col>
    //            </Row>
    //            <Row>
    //                <Col xs={2}>
    //                    Email:
    //                </Col>
    //                <Col xs={10}>
    //                    <div style={{ color: ((selectedProduct.email ?? '') == '' ? 'red' : 'black') }}>{(selectedProduct.email ?? '') == '' ? 'Not available' : selectedProduct.email}</div>
    //                </Col>
    //            </Row>
    //            <Row>
    //                <Col xs={2}>
    //                    Phone:
    //                </Col>
    //                <Col xs={10}>
    //                    <div style={{ color: ((selectedProduct.phone ?? '') == '' ? 'red' : 'black') }}>{(selectedProduct.phone ?? '') == '' ? 'Not available' : selectedProduct.phone}</div>
    //                </Col>
    //            </Row>
    //            <Row>
    //                <Col xs={2}>
    //                    Fax:
    //                </Col>
    //                <Col xs={10}>
    //                    <div style={{ color: ((selectedProduct.fax ?? '') == '' ? 'red' : 'black') }}>{(selectedProduct.fax ?? '') == '' ? 'Not available' : selectedProduct.fax}</div>
    //                </Col>
    //            </Row>
    //            //<Row>
    //            //    <Col xs={2}>
    //            //        Tax Reg #:
    //            //    </Col>
    //            //    <Col xs={10}>
    //            //        <div style={{ color: ((selectedProduct.taxRegNumber ?? '') == '' ? 'red' : 'black') }}>{(selectedProduct.taxRegNumber ?? '') == '' ? 'Not available' : selectedProduct.taxRegNumber}</div>
    //            //    </Col>
    //            //</Row>
    //            <Row>
    //                <Col xs={3}>
    //                    CDEX Sender Code:
    //                </Col>
    //                <Col xs={9}>
    //                    <div style={{ color: ((selectedProduct.majorAccountSenderCode ?? '') == '' ? 'red' : 'black') }}>{(selectedProduct.majorAccountSenderCode ?? '') == '' ? 'Not available' : selectedProduct.cdexSenderCode}</div>
    //                </Col>
    //            </Row>
    //        </>
    //    );
    //}

    //render detail pane (cdexTransactionCodes list)
    //const showDataEdit = () => {
    //    return (
    //        <>
    //            <ul style={{ listStyleType: "none", height: "515px", marginRight: '12px' }}>
    //                {selectedProduct.cdexTransactionRowDTO.data.map((cdexTransactionCode, index) => (
    //                    <li key={index} ref={(index == 0 ? companyTopRef : null)}
    //                        style={{ paddingLeft: '20px', marginLeft: '-42px', marginRight: '0px', fontSize: '.9rem' }}>
    //                        {/*onMouseOver={() => handleMouseOver(index)}*/}
    //                        {/*onMouseLeave={() => handleMouseLeave(index)}*/}
    //                        {/*onClick={() => handleMouseClick(index)}>*/}
    //                        <Row style={{
    //                            borderBottom: 'solid lightgray 1px',
    //                            //backgroundColor: (hoveredIndex == index ? '#9AC5F4' : (selectedProductIndex == index ? '#4F709C' : 'white')),
    //                            //color: (hoveredIndex == index ? 'white' : (selectedProductIndex == index ? 'white' : 'black'))
    //                        }} >
    //                            <Col xs={3} >
    //                                <div>{cdexTransactionCode.transactionCode}</div>
    //                            </Col>
    //                            <Col xs={3} >
    //                                <div>{cdexTransactionCode.transactionDesc}</div>
    //                            </Col>
    //                            <Col xs={3} >
    //                                {(() => {
    //                                    if (!cdexTransactionCode.isReadOnly) {
    //                                        return <Form.Group className="mb-3" controlId="cdexTransactionCode">
    //                                            <Form.Control name="cdexTransactionCode" size="xs" aria-label="CDEX Transaction Code" value={cdexTransactionCode.cdexTransactionCode} style={{ width: '100' }} onChange={(e) => handleTransactionChange(index, e)} />
    //                                        </Form.Group>
    //                                    }
    //                                    else {
    //                                        return <div>{cdexTransactionCode.cdexTransactionCode}</div>;
    //                                    }
    //                                })()}
    //                            </Col>
    //                            <Col xs={3} >
    //                                {(() => {
    //                                    if (!cdexTransactionCode.isReadOnly) {
    //                                        return <Form.Group className="mb-3" controlId="companyCode">
    //                                            <Form.Select name="revLineTypeCode" size="sm" aria-label="REV Line Type" value={cdexTransactionCode.revLineTypeCode} onChange={(e) => handleTransactionChange(index, e)} >
    //                                                {revLineTypes.map((type, i) => (
    //                                                    <option key={i} value={type.code}>{type.value}</option>
    //                                                ))}
    //                                            </Form.Select>
    //                                        </Form.Group>
    //                                    }
    //                                    else {
    //                                        switch (cdexTransactionCode.revLineTypeCode) {
    //                                            case 'R':
    //                                                return <div>REV</div>
    //                                            case 'T':
    //                                                return <div>TAX</div>
    //                                            case 'D':
    //                                                return <div>DED</div>
    //                                            case 'N':
    //                                                return <div>NET</div>
    //                                            default:
    //                                                return <div></div>
    //                                        }
    //                                    }
    //                                })()}
    //                            </Col>
    //                        </Row>
    //                    </li>
    //                ))}
    //            </ul>
    //        </>
    //    );
    //}

    //pagination example
    //https://github.com/lukaaspl/ellipsis-pagination/blob/master/src/components/Pagination.js

    //render input criteria
    const showInputCriteria = () => {
        const addBtn = {
            ...btnGold,
            fontSize: props.embedded ? '.8rem' : undefined,
            padding: props.embedded ? '2px 12px' : undefined,
            marginLeft: '8px',
            whiteSpace: 'nowrap'
        };
        return (
            <Container fluid>
                <Row>
                    <Col xs={5}>
                        <Button
                            size='sm'
                            style={{ ...btnGold, minWidth: props.embedded ? '160px' : '200px', padding: props.embedded ? '2px 12px' : undefined, fontSize: props.embedded ? '.8rem' : undefined, whiteSpace: 'nowrap' }}
                            onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                            onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                            disabled={!anyClassificationDirty}
                            onClick={anyClassificationDirty ? () => updateClassifications() : null}
                        >
                            Map Classification Codes
                        </Button>
                        <Button
                            size='sm'
                            style={addBtn}
                            onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                            onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                            onClick={handleAddAccount}
                        >
                            Add Account
                        </Button>
                    </Col>
                    {/*<Col xs={7}>*/}
                    {/*    <Button*/}
                    {/*        size='sm'*/}
                    {/*        style={{ width: '200px' }}*/}
                    {/*        disabled={!anyTransactionDirty}*/}
                    {/*        onClick={anyTransactionDirty ? () => updateTransactions() : null}*/}
                    {/*    >*/}
                    {/*        Map Transaction Codes*/}
                    {/*    </Button>*/}
                    {/*</Col>*/}
                </Row>
                <Row style={{ fontSize: props.embedded ? '.8rem' : '.9rem', marginTop: props.embedded ? '8px' : '20px', color: '#f1f1f1', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.04em' }} >
                    <Col xs={5}>
                        <Row>
                            <Col xs={7}>Major Account Desc</Col>
                            <Col xs={5}>Major Class Code</Col>
                        </Row>
                    </Col>
                    {/*<Col xs={7} style={{ borderLeft: 'solid black 1px' }} >*/}
                    {/*    <Row>*/}
                    {/*        <Col xs={3}>Interest Type Code</Col>*/}
                    {/*        <Col xs={3}>Interest Type Desc</Col>*/}
                    {/*        <Col xs={3}>CDEX Transaction Code</Col>*/}
                    {/*        <Col xs={3}>REV Line Type</Col>*/}
                    {/*    </Row>*/}
                    {/*</Col>*/}
                </Row>

            </Container>
        );
    }

    return (
        <div>
            {!props.embedded && (
                <p style={{ fontSize: '1.75rem', fontWeight: '700', color: '#333333', margin: '16px 0 4px 0', textAlign: 'center' }}>JIB Classification Mappings</p>
            )}
            {(() => {
                switch (pageStatus) {
                    case 'loading':
                        return showPageLoading()
                    case 'ready':
                        return showTableContainer()
                    case 'error':
                        return showPageError()
                    default:
                        return <p>No Page Loaded.</p>
                }
            })()}
        </div>
    );
}

export default ClassificationCodes_dc;
